import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/dev/demos")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/dev/demos" })
  },
  component: () => null,
})
